import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Form, Modal, Button, Space, Typography } from "antd";
import FormItemCheckbox from "../forms/FormItemCheckbox";
import { useForm } from "react-hook-form";
import { FileOutlined, CheckOutlined } from "@ant-design/icons";

const { Text, Paragraph } = Typography;

const RegistrationConfirmationModal = ({ onSubmit, onClose, visible }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      title={
        <Space>
          <FileOutlined />
          CERN SSO Policy Requirements
        </Space>
      }
      width={700}
      centered
      closable
    >
      <Paragraph style={{ marginTop: 24 }}>
        Before submitting your SSO registration, please confirm that you have
        read, understood and will ensure that this application abides by:
      </Paragraph>

      <Form onSubmit={handleSubmit(onSubmit)}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <FormItemCheckbox
            name="computingRules"
            label={
              <>
                The{" "}
                <a
                  href="https://security.web.cern.ch/rules/en/OC5_english.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  CERN Computing Rules <Text type="danger">*</Text>
                </a>
              </>
            }
            control={control}
            required
            error={errors.computingRules}
          />

          <FormItemCheckbox
            name="dataPrivacy"
            label={
              <>
                The{" "}
                <a
                  href="http://cds.cern.ch/record/2651311"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  CERN Data Privacy regulations <Text type="danger">*</Text>
                </a>
              </>
            }
            control={control}
            required
            error={errors.dataPrivacy}
          />

          <FormItemCheckbox
            name="cloudPolicy"
            label={
              <>
                In the case of a cloud service hosted outside, the{" "}
                <a
                  href="https://cloud-licence-office.web.cern.ch/content/policy-cloud-usage-cern"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Policy for Cloud Usage at CERN
                </a>
              </>
            }
            control={control}
            required={false}
            error={null}
          />

          <FormItemCheckbox
            name="contacts"
            label={
              <>
                Acknowledging that the owner and/or admin contact information is
                accurate, will be kept up-to-date, and may be informed in the
                event of a suspected security incident{" "}
                <Text type="danger">*</Text>
              </>
            }
            control={control}
            required
            error={errors.contacts}
          />
        </Space>
        <div style={{ textAlign: "right", marginTop: 24 }}>
          <Button
            type="primary"
            htmlType="submit"
            id="submitButton"
            disabled={Object.keys(errors).length > 0}
            onClick={handleSubmit(onSubmit)}
            icon={<CheckOutlined />}
          >
            Submit
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

RegistrationConfirmationModal.propTypes = {
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  visible: PropTypes.bool,
};

export default connect(() => ({}), {})(RegistrationConfirmationModal);
